import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { AppSettings } from 'src/app/app.settings';
import { Component, OnInit, Input, AfterViewInit, QueryList, ViewChild } from '@angular/core';
import { PartInfo } from 'src/app/models/partinfo';
import { ProposalService } from 'src/app/services/proposal.service';
import { Observable, of } from 'rxjs';
import { GridData, DataStateChangeEvent } from '@tesla/angular2-tesla-common/grid/grid.models';
import Helper from 'src/app/core/utility/helper';
import { PartBasicInfo } from 'src/app/models/partbasicinfo';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { ReviewProposalPartInfo } from 'src/app/models/internal/reviewproposalpartinfo2';
import * as moment from 'moment/moment';
import { UpdateProposalStatusDTO } from 'src/app/models/internal/updateproposalstatusdto';
import { Constants } from 'src/app/core/constants';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { TeslaGridComponent } from '@tesla/angular2-tesla-common/tesla-common';
import { tap } from 'rxjs/operators';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { QueryByStatusDTO } from 'src/app/models/internal/query-bystatus-dto';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { UserData } from '../../../models/auth/userdata';
import { SelectedAutocompleteValue } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.model';
import { SourceType } from 'src/app/models/sourcetype';
import { PartSystemDTO } from 'src/app/models/external/partsystem-dto';
import { ProposalExternalComment } from 'src/app/models/proposal-external-comment';
import { QueryExternalCommentUnReadDTO } from 'src/app/models/internal/query-external-comment-unread-dto';
import { QueryUpdateExternalCommentReadStatusDTO } from 'src/app/models/internal/query-external-comment-update-read-status-dto copy';
import { AppGlobalDataService } from 'src/app/services/appglobaldata.service';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-proposal-history',
  templateUrl: './proposal-history.component.html',
  styleUrls: ['./proposal-history.component.scss']
})
export class ProposalHistoryComponent extends BaseGridPage implements OnInit, AfterViewInit  {
  @Input() ProposalId: string;
  unReadcommentsList: ProposalExternalComment[];
  constructor(        private appGlobalDataService: AppGlobalDataService,
    private dataService: DataService,
    private proposalService: ProposalService,
    localstorageService: LocalstorageService,
    private router: Router,
    private fb: FormBuilder,
    private toastService: ToastService,
    logger: NGXLogger,
    appSettings: AppSettings,
) { 
  super(localstorageService, logger, appSettings);
}

ngOnInit() {
  this.initFilterValues();
  this.fillGrid();
}
fillGrid(): void {
this.filter.Skip = this.skip;
this.filter.Take = this.pageSize;
this.getUnreadProposalStatusHistory();
}
getUnreadProposalStatusHistory() {
  this.dataService.getProposalStatusHistory(this.ProposalId).subscribe((response: any) => {
        if (response && response.Data != null) {
            this.unReadcommentsList = response.Data;
            this.gridView = of({
                data: response.Data,
                total: response.Total ? response.Total : 0,
            });
            this.appGlobalDataService.RefreshUnreadMessageCount(response.Total);
        }
    });
  }


}
